export default __webpack_public_path__ + "static/media/toyz.28ba72ee.png";